<template>
  <div
    v-if="$rsGlobals.$language !== 'en' || show"
    class="rs-translation-message alert alert-warning w-100 mb-3"
  >
    <strong>Translating Content</strong>
    <ul>
      <li>While editing non-English content, some editing features may be hidden / disabled.</li>
      <li>Empty inputs in non-English content are filled in with English values (if they exist) in ads and website content.</li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTranslationMessage',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.rs-translation-message {
  ul {
    margin-left: 2rem;
  }
  li {
    list-style-type: initial;
  }
}

</style>
